module.exports = __webpack_public_path__ + "static/media/Programing-lg_1x.1f0ed41c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/Programing/Programing-lg_1x.webp
// module id = 759
// module chunks = 0